'use client';

import { useEffect, useState } from 'react';
import { GoogleTagManager } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';

const DeferredTagManager = ({ gtmId }: { gtmId: string }) => {
  const [enabled, setEnabled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    if (!gtmId) return;
    if (pathname.includes('/360')) return;
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return;
    }

    const enableTracking = () => setEnabled(true);
    const events: (keyof WindowEventMap)[] = ['pointerdown', 'keydown', 'touchstart', 'scroll'];

    for (const eventName of events) {
      window.addEventListener(eventName, enableTracking, { once: true, passive: true });
    }

    return () => {
      for (const eventName of events) {
        window.removeEventListener(eventName, enableTracking);
      }
    };
  }, [gtmId]);

  if (!enabled || !gtmId) return null;

  return <GoogleTagManager gtmId={gtmId} />;
};

export default DeferredTagManager;
